import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

// (window as any).__forceSmoothScrollPolyfill__ = true;
// import smoothscroll from "smoothscroll-polyfill";
// smoothscroll.polyfill();

import { hoverPeak } from "../../../store/selection/actions";

import { ParsedRecord } from "../../../types/airtable";
import placeholderImg from "../../../assets/placeholder-thumb.png";

import "./PreviewCard.scss";

interface IOnClick {
  (record: ParsedRecord): void;
}

type PreviewCardProps = {
  focused: boolean;
  record: ParsedRecord;
  onClick: IOnClick;
};

const PreviewCard = ({ focused, record, onClick }: PreviewCardProps) => {
  const useStyles = makeStyles({
    root: {
      // maxWidth: 360,
      width: "100%",
      borderRadius: 0,
      backgroundColor: "#5d6168", // #3e4249
      color: "white"
    },
    media: {
      // height: 270
    },
    mediaDim: {
      // height: 270,
      opacity: 0.5
    }
  });
  const classes = useStyles();
  const dispatch = useDispatch();

  const ref = React.createRef<HTMLDivElement>();

  const scrollToCard = () => {
    ref.current?.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "center"
    });
  };

  useEffect(() => {
    if (focused) {
      scrollToCard();
    }
  }, [focused]);

  const thumbnailImage = record.IMAGES.find((img) => img.isPrimary);

  return (
    <Card
      ref={ref}
      className={`${classes.root} preview-card`}
      onClick={() => onClick(record)}
      onMouseEnter={() => dispatch(hoverPeak(record.PEAK_ID))}
      onMouseLeave={() => dispatch(hoverPeak(null))}
    >
      <CardActionArea>
        <CardMedia
          component="img"
          className={thumbnailImage ? classes.media : classes.mediaDim}
          image={thumbnailImage?.thumbnailUrls.medium || placeholderImg}
          title={record.NAME || ""}
        />
        <CardContent>
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
          >
            <Typography variant="subtitle1" component="h2">
              {record.NAME}
            </Typography>
            <Typography variant="subtitle2" component="h3">
              {record.ELEVATION + "'"}
            </Typography>
          </Grid>
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
          >
            <Typography variant="subtitle2" component="h3">
              {record.STATE}
            </Typography>
            <Typography variant="subtitle2" component="h3">
              {record.SUMMIT_DATE?.toLocaleDateString() || "TBD"}
            </Typography>
          </Grid>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default React.memo(PreviewCard, (prevProps, nextProps) => {
  return prevProps.focused == nextProps.focused;
});
